import axios from 'axios';

export default {
    poll(guids) {
        return axios.post('/runningTasks/poll', { guids });
    },
    cancel(guid) {
        return axios.post('/runningTasks/cancel', { guid });
    },
    removeFromCache(guid) {
        return axios.post('/runningTasks/removeFromCache', { guid });
    },
};
